import { createStyles } from '@mantine/core';

// TODO: RESPONSIVE styles for mobile
const useStyles = createStyles((theme) => ({
  signUpContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto auto',
    minHeight: '100%',
    background: theme.white,

    [`@media(min-width: ${theme.breakpoints.md}px)`]: {
      display: 'grid',
      gridTemplateRows: 'auto',
      gridTemplateColumns: '1fr 1fr',
      justifyItems: 'center',
      alignContent: 'stretch',
    },
  },
}));

export default useStyles;
